const apiEndpoints = {
  appControl: {
    versionInfo: "general/app-status/",
  },
  common: {
    notification: "user/notifications/",
    uploadMedia: "general/upload-media/",
  },
  auth: {
    register: "user/register/",
    login: "user/login/",
    verifyOtp: "user/verify-otp/",
    refresh: "user/token/refresh/",
    updateFCMToken: "user/register-token/",
    deleteAccount: "user/delete-user/",
  },
  cards: {
    getDesigns: "subscription/get-card-designs/",
    makeActive: "user/make-profile-active/",
    addCardJson: "user/add-card-json/",
  },
  subscription: {
    getPlans: "subscription/get-plans/",
    getProdileCards: "subscription/get-profile-card/",
    addCard: "subscription/add-card-with-profile/",
    start: "subscription/start-subscription/",
    complete: "subscription/complete-subscription/",
  },
  profile: {
    getPortfolioJson: "user/get_organization_profile/",
    updatePortfolioJson: "user/update_user_origanization_profile_json/",
    getProfileCards: "user/get_profile_cards/",
    makeOrganizationCardActive: "user/make-organization-card-active/",
    getStatistics: "user/get-statistics/",
    createPersonal: "user/create-personal-profile/",
    updateCardJson: "user/update-card-json/",
    createBusiness: "user/create-business-profile/",
    updatePersonal: "user/update-personal-profile/",
    updateBusiness: "user/update-business-profile/",
    getDetails: "user/get-profile-detail/",
    get: "user/get-profile/",
    getCardProfile: "user/get-profile-info/",
    update: "user/update-profile/",
    list: "user/get-profile-list/",
    addVideo: "user/add-intro-video/",
    getVideo: "user/get-profile-intro-video/",
    getActiveCard: "user/get-active-profile/",
    updateProfileType: "user/update-profile-type/",
    uploadImageCard: "user/capture-card-image/",
    customUrls: {
      create: "user/add-custom-links/",
      update: "user/update-custom-links/",
      delete: "user/delete-custom-links/",
      list: "user/get-custom-links/",
    },
  },

  additionalInfo: {
    getAll: "user/get-profile-preference/",
    Comm: {
      list: "user/get-communication-preference/",
      get: "",
      update: "user/update-communication-preference/",
      delete: "user/remove-communication-preference/",
      create: "user/create-communication-preference/",
      media: "general/get-communication-media/",
      assign: "user/assign-communication-profile/",
      removeAssigned: "user/remove-profile-communication-preference/",
    },
    Social: {
      list: "user/get-social-media-preference/",
      get: "",
      update: "user/update-social-media-preference/",
      delete: "user/remove-social-media-preference/",
      create: "user/create-social-media-preference/",
      media: "general/get-social-media/",
      assign: "user/assign-social-media-profile/",
      removeAssigned: "user/remove-profile-social-media-preference/",
    },

    Reviews: {
      list: "user/get-review-preference/",
      get: "",
      update: "user/update-review-preference/",
      delete: "user/remove-review-preference/",
      create: "user/create-review-preference/",
      media: "general/get-reviews-media/",
      assign: "user/assign-review-profile/",
      removeAssigned: "user/remove-profile-review-preference/",
    },
  },
  connection: {
    connect: "user/make-connection/",
    list: "user/get-all-connection-users/",
    groups: "user/get-connection-groups/",
    search: "user/search-profile/",
    request: "user/send-request/",
    getRequests: "user/get-requests/",
    acceptRequest: "user/accept-request/",
    addFolder: "user/create-folder/",
    getFolders: "user/get-folders/",
    getFolderUsers: "user/get-folder-info/",
    addToFolder: "user/add-profile-folder/",
  },
  share: {
    remote: {
      create: "user/create-join-remote-group/",
      getUsers: "user/get-remote-group-user/",
    },
    search: {
      list: "user/search-profile/",
    },
  },
  organization: {
    create: "user/create-organization/",
    update: "user/update-organization/",
    getList: "user/get-organizations/",
    getDetails: "user/get-organization-details/",
    addMember: "user/add-organization-member/",
    removeMember: "user/remove-organization-member/",
    updateMemberRole: "user/update-member-role/",
    getPortfolioJson: "user/get_organization_profile/",
    updatePortfolioJson: "user/update_user_origanization_profile_json/",
    makeCardActive: "user/make-organization-card-active/",
  },
  analytics: {
    getOverview: "user/get-analytics-overview/",
    getCardViews: "user/get-card-views/",
    getProfileViews: "user/get-profile-views/",
    getConnectionStats: "user/get-connection-stats/",
    getShareStats: "user/get-share-stats/",
    getStatistics: "user/get-statistics/",
  },
  portfolio: {
    get: "user/get-portfolio/",
    update: "user/update-portfolio/",
    getTemplates: "user/get-portfolio-templates/",
    addProject: "user/add-portfolio-project/",
    updateProject: "user/update-portfolio-project/",
    removeProject: "user/remove-portfolio-project/",
  },
  sharing: {
    generateLink: "user/generate-share-link/",
    getSharedProfiles: "user/get-shared-profiles/",
    trackShare: "user/track-share/",
    updateShareSettings: "user/update-share-settings/",
  },
  public: {
    getOrganizationInfo: "user/get_organizarion_info/", // Note: Keeping API's spelling
    getOrganizationPreview: "user/get_organizarion_preview/",
  },
};

export default apiEndpoints;
